import { render, staticRenderFns } from "./TableRowItem.vue?vue&type=template&id=2c43ffa7&scoped=true&"
import script from "./TableRowItem.vue?vue&type=script&lang=js&"
export * from "./TableRowItem.vue?vue&type=script&lang=js&"
import style0 from "./TableRowItem.css?vue&type=style&index=0&id=2c43ffa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c43ffa7",
  null
  
)

export default component.exports